import { render } from "./ContributorListModal.vue?vue&type=template&id=f7376e16"
import script from "./ContributorListModal.vue?vue&type=script&lang=js"
export * from "./ContributorListModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__